/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global lng */

function FormExportCsvBuilder() {
  if (!this instanceof FormExportCsvBuilder) return new FormExportCsvBuilder();

  const that = this;

  this.formSchema;

  this.loadFormSchema = loadFormSchema;
  this.load = load;
  this.getJson = getJson;
  this.onclose = (json) => console.warn("onclose() should be overwriten");
  this.oncancel = () => console.warn("oncancel() should be overwriten");

  this.node = document.createElement("div");
  this.node.classList.add("formExportCsv-builder");
  this.node.insertAdjacentHTML(
    "beforeend",
    `
        <div class="export">
            <div class="control-bar">
                <i class="ok material-icons">save</i>
                <i class="close material-icons">close</i>
                <h3>${lng.get("csvform-export-configuration")}</h3>
                <i class="delete material-icons">delete</i>
            </div>
            <div class="export-content">

            </div>
        </div>
        <div class="blueprints">
            <div class="control-bar">
                <h3>${lng.get("csvform-export-preform")}</h3>
            </div>
        </div>
    `
  );

  /**
   * @type Element
   */
  const exportLis2 = this.node.querySelector("div.export");
  const exportLis = this.node.querySelector("div.export-content");
  /**
   * @type Element
   */
  const blueprints = this.node.querySelector(".blueprints");
  /**
   * @type Element
   */
  const deleteArea = this.node.querySelector(".delete");

  const saveButton = this.node.querySelector("i.ok");
  const cancelButton = this.node.querySelector("i.close");

  //init drag & drop

  exportLis.data = {
    inDrag: null,
  };
  exportLis2.addEventListener("dragover", function (e) {
    e.preventDefault();

    //search for other input
    let target = e.target;
    while (target !== this) {
      if (target.classList.contains("input")) break;
      target = target.parentNode;
    }

    let allTargets = exportLis.querySelectorAll(".item");

    //remove old flags
    Array.from(
      this.querySelectorAll(".input.insert-before, .input.insert-after")
    ).forEach((flagged) => {
      if (flagged !== target) {
        flagged.classList.remove("insert-before");
        flagged.classList.remove("insert-after");
      }
    });

    if (e.clientY > target.offsetTop + 30) {
      target.classList.remove("insert-before");
      target.classList.add("insert-after"); //highlight the input under the cursor
    } else {
      target.classList.remove("insert-after");
      target.classList.add("insert-before"); //highlight the input under the cursor
    }

    //highlight the remove area
    if (e.target === deleteArea) deleteArea.classList.add("highlight");
    else deleteArea.classList.remove("highlight");

    // auto scroll if user drags to top or bottom
    // down?
    const scrollWrapper = exportLis2;
    const distanceToBottm = window.innerHeight - e.clientY;
    const distanceToTop = e.clientY;
    if (distanceToBottm < 150) {
      scrollWrapper.scrollTop = scrollWrapper.scrollTop + 2;
    }
    if (distanceToTop < 250) {
      // bigger cause of header
      scrollWrapper.scrollTop = scrollWrapper.scrollTop - 2;
    }
  });

  exportLis2.addEventListener("drop", function (e) {
    e.preventDefault();

    const text = e.dataTransfer.getData("text");
    const key = e.dataTransfer.getData("key");
    const type = e.dataTransfer.getData("type");
    const defaultInputType = e.dataTransfer.getData("defaultInputType");

    let object = type;

    if (e.dataTransfer.getData("object")) {
      object = JSON.parse(e.dataTransfer.getData("object"));
    }

    const newLi =
      exportLis.data.inDrag ||
      genSchemaItemNode(
        object,
        text,
        key,
        null,
        null,
        null,
        null,
        defaultInputType
      );

    deleteArea.classList.remove("highlight");
    if (e.target === deleteArea) {
      if (newLi.parentNode) newLi.parentNode.removeChild(newLi);
      return;
    }
    //get flagged
    let flagged = this.querySelector(".input.insert-before");
    if (!flagged) {
      exportLis.appendChild(newLi);
      return;
    }

    flagged.classList.remove("insert-before");
    exportLis.insertBefore(newLi, flagged);
  });

  cancelButton.addEventListener("click", function (e) {
    that.node.parentNode.removeChild(that.node);
    that.oncancel();
  });
  deleteArea.addEventListener(`click`, function (e) {
    console.log("deletebuttonpress");
  });
  saveButton.addEventListener(`click`, function (e) {
    const data = getJson();
    that.onclose(data);
    that.node.parentNode.removeChild(that.node);
  });

  /**
   *
   * @param {string} schema
   * @returns {undefined}
   */
  function loadFormSchema(schema) {
    schema = JSON.parse(schema);
    that.formSchema = schema;
    const nodes = [];

    FormExportCsvBuilder.reserved.map((r) =>
      nodes.push(genSchemaItemNode(r, "", r))
    );
    schema.map((schemaItem) => {
      let key;
      switch (schemaItem.type) {
        case "image":
        case "sign":
        case "hr":
          //ignore
          return;
        case "text":
          key = schemaItem.meta.name;
          nodes.push(genSchemaItemNode(schemaItem, keyToLabel(key), key));
          break;
        case "textArea":
          key = schemaItem.meta.name;
          nodes.push(genSchemaItemNode(schemaItem, keyToLabel(key), key));
          break;
        case "multichoice":
          key = schemaItem.meta.name;
          nodes.push(genSchemaItemNode(schemaItem, keyToLabel(key), key));
          break;
        case "raffle":
          key = schemaItem.meta.name;
          nodes.push(genSchemaItemNode(schemaItem, keyToLabel(key), key));
          break;
        case "tel":
          let telKeys = ["mobiletel", "festtel"];
          if (schemaItem.meta.vorwahl)
            telKeys = ["vwmobile", "mobiletel", "vwfest", "festtel"];
          telKeys.map((telKey) => {
            const key = schemaItem.meta.name + "." + telKey;
            nodes.push(genSchemaItemNode(schemaItem, keyToLabel(key), key));
          });
          break;
        case "address":
          let addressKeys = [
            "postalCode",
            "city",
            "street",
            "houseNumber",
            "houseNumberExtra",
          ];
          if (schemaItem.meta.epaper)
            addressKeys = [
              "postalCode",
              "city",
              "street",
              "houseNumber",
              "houseNumberExtra",
              "print",
              "epaper",
            ];

          addressKeys.map((addrKey) => {
            const key = schemaItem.meta.name + "." + addrKey;
            nodes.push(
              genSchemaItemNode(
                schemaItem,
                keyToLabel(key), //example: Zustelladresse: Hausnummer
                key
              )
            ); //example: deliveryAddress.houseNumber
          });
          break;
        case "default":
          schemaItem.data.map((defaultItem) => {
            const key = schemaItem.meta.name + "." + defaultItem.name;
            nodes.push(
              genSchemaItemNode(
                schemaItem,
                keyToLabel(key), //example: Name: Vorname
                key,
                null,
                null,
                null,
                null,
                defaultItem.type
              )
            ); //example: name.firstname
          });
          break;
        default:
          console.error(`Type ${schemaItem.type} not implemented`);
      }
    });

    requestAnimationFrame(() => {
      nodes.map((n) => {
        n.classList.add("blueprint");
        n.classList.add("item");
        blueprints.appendChild(n);
      });
    });
  }

  function load(data) {
    data = JSON.parse(data);

    const nodes = [];
    data.map((i) => {
      nodes.push(
        genSchemaItemNode(
          i,
          keyToLabel(i.key),
          i.key,
          i.prefix,
          i.n,
          i.label,
          i.function,
          i.defaultInputType
        )
      );
    });

    requestAnimationFrame(() => {
      nodes.map((i) => exportLis.appendChild(i));
    });
  }

  function getJson() {
    let labels = exportLis.querySelectorAll("label:first-of-type");
    labels = Array.from(labels);

    const data = labels.reduce(function (result, i) {
      const functionSelect =
        i.parentNode.parentNode.parentNode.querySelector(".function-select");
      let selectedFunction = null;

      if (functionSelect && functionSelect.selectedIndex > 0) {
        selectedFunction =
          functionSelect.options[functionSelect.selectedIndex].value;
      }

      let label, prefixInput;
      switch (i.key) {
        case undefined:
          break;
        case "empty":
          const nInput = i.parentNode.parentNode.children[1].children[1];
          label = i.parentNode.parentNode.children[1].children[0];
          prefixInput = i.parentNode.parentNode.children[1].children[2];
          result.push({
            type: "empty",
            key: i.key,
            label: label.value.split(";").join("").split("\n").join(""),
            prefix: prefixInput.value.split(";").join("").split("\n").join(""),
            n: nInput.value,
          });
          break;
        case "date":
          label = i.parentNode.parentNode.children[1].children[0];

          prefixInput = i.parentNode.parentNode.children[1].children[1];
          const data = {
            type: "date",
            key: i.key,
            label: label.value.split(";").join("").split("\n").join(""),
            prefix: prefixInput.value.split(";").join("").split("\n").join(""),
          };

          if (selectedFunction) {
            data.function = selectedFunction;
          }

          result.push(data);
          break;
        case "employee":
        case "location":
        case "marketnumber":
          label = i.parentNode.parentNode.children[1].children[0];
          prefixInput = i.parentNode.parentNode.children[1].children[1];

          const csvData = {
            type: i.key,
            key: i.key,
            label: label.value.split(";").join("").split("\n").join(""),
            prefix: prefixInput.value.split(";").join("").split("\n").join(""),
          };

          if (selectedFunction) {
            csvData.function = selectedFunction;
          }

          result.push(csvData);
          break;
        case "employeenumber":
          label = i.parentNode.parentNode.children[1].children[0];
          prefixInput = i.parentNode.parentNode.children[1].children[1];
          result.push({
            type: "employeenumber",
            key: i.key,
            label: label.value.split(";").join("").split("\n").join(""),
            prefix: prefixInput.value.split(";").join("").split("\n").join(""),
          });
          break;
        case "customerid":
          label = i.parentNode.parentNode.children[1].children[0];
          prefixInput = i.parentNode.parentNode.children[1].children[1];
          result.push({
            type: "customerid",
            key: i.key,
            label: label.value.split(";").join("").split("\n").join(""),
            prefix: prefixInput.value.split(";").join("").split("\n").join(""),
          });
          break;
        case "customerid_intern":
          label = i.parentNode.parentNode.children[1].children[0];
          prefixInput = i.parentNode.parentNode.children[1].children[1];
          result.push({
            type: "customerid_intern",
            key: i.key,
            label: label.value.split(";").join("").split("\n").join(""),
            prefix: prefixInput.value.split(";").join("").split("\n").join(""),
          });
          break;
        case "zipEdition":
        case "delivery_end":
          label = i.parentNode.parentNode.children[1].children[0];
          prefixInput = i.parentNode.parentNode.children[1].children[1];
          result.push({
            type: i.key,
            key: i.key,
            label: label.value.split(";").join("").split("\n").join(""),
            prefix: prefixInput.value.split(";").join("").split("\n").join(""),
          });
          break;
        case "subscriptionType":
          label = i.parentNode.parentNode.children[1].children[0];
          const epaperInput = i.parentNode.parentNode.children[1].children[1];
          const printInput = i.parentNode.parentNode.children[1].children[2];
          result.push({
            type: "subscriptionType",
            key: i.key,
            label: label.value.split(";").join("").split("\n").join(""),
            epaperValue: epaperInput.value
              .split(";")
              .join("")
              .split("\n")
              .join(""),
            printValue: printInput.value
              .split(";")
              .join("")
              .split("\n")
              .join(""),
          });
          break;
        case "iban":
          label = i.parentNode.parentNode.children[1].children[0];
          prefixInput = i.parentNode.parentNode.children[1].children[1];

          result.push({
            type: "iban",
            key: i.key,
            label: label.value.split(";").join("").split("\n").join(""),
            prefix: prefixInput.value.split(";").join("").split("\n").join(""),
          });
          break;
        case "increasing_num":
          label = i.parentNode.parentNode.children[1].children[0];
          const numberInput = i.parentNode.parentNode.children[1].children[1];
          result.push({
            type: "increasing_num",
            key: i.key,
            label: label.value.split(";").join("").split("\n").join(""),
            n: numberInput.value.split(";").join("").split("\n").join(""),
          });
          break;
        default:
          prefixInput = i.parentNode.parentNode.children[1].children[0];
          let labelContext = i.textContent;
          let customLabelContext = null;
          prefixInput.value = prefixInput.value
            .split(";")
            .join("")
            .split("\n")
            .join("");
          const checkInput = i.parentNode.parentNode.children[1].children[1];

          // The address-element has a description input
          if (
            i.type === "address" &&
            i.parentNode.parentNode.parentNode.children[1]
          ) {
            let addressTr = i.parentNode.parentNode.parentNode.children[1];
            let addressInput = addressTr.querySelector(
              "input[name='address-input']"
            );
            customLabelContext =
              addressInput.value && addressInput.value.length > 0
                ? addressInput.value
                : "";
          }

          let functionsCount = i.functionsCount;
          let defaultInputType = i.defaultInputType;
          let dynamicFunctionValueInput =
            i.parentNode.parentNode.parentNode.querySelector(
              "#dynamicFunctionValue"
            );
          const singleColumnInput =
            i.parentNode.parentNode.parentNode.querySelector(
              ".singleColumnExport"
            );

          if (checkInput) {
            // Address-Element
            const defaultData = {
              type: i.type,
              key: i.key,
              prefix: prefixInput.value,
              label: labelContext, //i.textContent
              customLabel: customLabelContext,
              n: checkInput.checked ? 1 : -1,
              functionsCount: functionsCount,
            };

            if (selectedFunction) {
              defaultData.function = selectedFunction;
              if (dynamicFunctionValueInput) {
                defaultData.dynamicFunctionValue =
                  dynamicFunctionValueInput.value;
              }
            }

            if (singleColumnInput && singleColumnInput.checked) {
              defaultData.singleColumn = true;
            } else if (singleColumnInput) {
              defaultData.singleColumn = false;
            }

            if (defaultInputType) {
              defaultData.defaultInputType = defaultInputType;
            }

            result.push(defaultData);
          } else {
            labelContext = labelContext.split(": ");
            labelContext = labelContext[1] ? labelContext[1] : labelContext[0];

            const customLabelInput =
              i.parentNode.parentNode.parentNode.querySelector(
                "input[name='customLabelInput']"
              );
            let customLabel = null;

            if (customLabelInput && customLabelInput.value) {
              customLabel = customLabelInput.value;
            }

            const defaultData = {
              type: i.type,
              key: i.key,
              prefix: prefixInput.value,
              label: labelContext,
              customLabel: customLabel,
              functionsCount: functionsCount,
            };

            if (singleColumnInput && singleColumnInput.checked) {
              defaultData.singleColumn = true;
            } else if (singleColumnInput) {
              defaultData.singleColumn = false;
            }

            if (selectedFunction) {
              defaultData.function = selectedFunction;
              if (dynamicFunctionValueInput) {
                defaultData.dynamicFunctionValue =
                  dynamicFunctionValueInput.value;
              }
            }

            if (defaultInputType) {
              defaultData.defaultInputType = defaultInputType;
            }

            result.push(defaultData);
          }
      }
      return result;
    }, []);
    return JSON.stringify(data);
  }

  /**
   * Generate a draggable node.
   * @param object
   * @param {string} text for label
   * @param {string} key key pattern to identify in form
   * use <i>empty</i> to create a spacer column.
   * @param {string} value
   * the prefixvalue for euch item in the column
   * @param {number} n
   * For 'key=empty' and address (to set the prefix or not)
   * * @param emptylabel
   * * @param functionValue
   * * @param defaultInputType
   * * @returns {Element}
   */
  function genSchemaItemNode(
    object,
    text,
    key,
    value,
    n,
    emptylabel,
    functionValue,
    defaultInputType
  ) {
    let type = object;

    if (object && object.type) {
      type = object.type;
    }

    const schemaNode = createSchemaNode(text, key);
    let functions = getFunctionsForType(type, object, key);

    if (defaultInputType && defaultInputType === "tel") {
      functions = getFunctionsForType(defaultInputType, object, key);
    } else {
      defaultInputType = null;
    }

    if (
      !functions.length &&
      type === "default" &&
      object.data &&
      object.data.length > 0
    ) {
      functions = getFunctionsForType(object.data[0].type);
      type = object.data[0].type;
    }

    if (
      object &&
      object.functionsCount !== null &&
      object.functionsCount === 0 &&
      functions.length > 0
    ) {
      // Loaded elements from the API return the functionCount
      functions = [];
    }

    if (
      object &&
      object.type === "raffle" &&
      object.data &&
      object.data.text2 !== undefined
    ) {
      // raffle elements with more than one answer can't use the X function
      functions = [];
    }

    schemaNode.insertAdjacentHTML(
      "beforeend",
      `
            <tr>
                <td colspan=2 class="labels">
                </td>
                <td colspan=8 class="inputs csv-inputs">
                </td>
            </tr>
        `
    );
    const label = document.createElement("label");
    let input;
    let secondInput;
    let thirdInput;

    let miscTr = null;

    label.textContent = text;
    label.key = key;
    label.type = type;
    label.functionsCount = functions.length;
    label.defaultInputType = defaultInputType;

    const labelInput = schemaNode.querySelector(".labels");
    const nodeInput = schemaNode.querySelector(".inputs");

    if (FormExportCsvBuilder.reserved.indexOf(key) !== -1) {
      label.textContent = lng.get("formExport-reserved_" + key);

      switch (key) {
        case "empty":
          input = document.createElement("input");
          input.type = "text";
          input.key = key;
          input.placeholder = lng.get("formExport-placeholder");
          if (value !== undefined) input.value = emptylabel;
          secondInput = document.createElement("input");
          secondInput.type = "number";
          secondInput.placeholder = lng.get("formExport-placeholder_empty");
          secondInput.classList.add("placeholder_number");
          secondInput.min = 1;
          secondInput.step = 1;
          secondInput.size = 5;
          secondInput.value = n || 1;
          thirdInput = document.createElement("input");
          thirdInput.type = "text";
          thirdInput.key = key;
          thirdInput.placeholder = lng.get("formExport-placeholder_prefix");
          if (value !== undefined) thirdInput.value = value;
          break;
        case "date":
          input = document.createElement("input");
          input.type = "text";
          input.key = key;
          input.placeholder = lng.get("formExport-placeholder");
          if (value !== undefined) input.value = emptylabel;

          thirdInput = document.createElement("input");
          thirdInput.type = "text";
          thirdInput.key = key;
          thirdInput.placeholder = lng.get("formExport-placeholder_prefix");
          if (value !== undefined) thirdInput.value = value;
          break;
        case "employee":
        case "employeenumber":
        case "customerid":
        case "customerid_intern":
        case "delivery_end":
        case "iban":
        case "zipEdition":
        case "location":
        case "marketnumber":
          input = document.createElement("input");
          input.type = "text";
          input.key = key;
          input.placeholder = lng.get("formExport-placeholder");
          if (emptylabel !== undefined) input.value = emptylabel;

          secondInput = document.createElement("input");
          secondInput.type = "text";
          secondInput.key = key;
          secondInput.placeholder = lng.get("formExport-placeholder_prefix");
          if (value !== undefined) secondInput.value = value;
          break;
        case "increasing_num":
          input = document.createElement("input");
          input.type = "text";
          input.key = key;
          input.placeholder = lng.get("formExport-placeholder");
          if (emptylabel !== undefined) input.value = emptylabel;

          secondInput = document.createElement("input");
          secondInput.type = "number";
          secondInput.key = key;
          secondInput.placeholder = lng.get(
            "formExport-placeholder_increasing_num"
          );
          if (n !== undefined) secondInput.value = "" + n;
          break;
        case "subscriptionType":
          input = document.createElement("input");
          input.type = "text";
          input.key = key;
          input.placeholder = lng.get("formExport-placeholder");
          if (emptylabel !== undefined) input.value = emptylabel;

          secondInput = document.createElement("input");
          secondInput.type = "text";
          secondInput.key = key;
          secondInput.placeholder = lng.get("formExport-placeholder_epaper");
          if (object.epaperValue !== undefined)
            secondInput.value = object.epaperValue;

          thirdInput = document.createElement("input");
          thirdInput.type = "text";
          thirdInput.key = key;
          thirdInput.placeholder = lng.get("formExport-placeholder_print");
          if (object.printValue !== undefined)
            thirdInput.value = object.printValue;
          break;
        default:
          input = document.createElement("input");
          input.type = "text";
          input.key = key;
          input.placeholder = lng.get("formExport-placeholder_prefix");
          if (value !== undefined) input.value = value;
      }
    } else {
      input = document.createElement("input");
      input.type = "text";
      input.key = key;
      input.placeholder = lng.get("formExport-placeholder_prefix");

      if (
        type === "text" ||
        type === "email" ||
        type === "default" ||
        type === "select" ||
        type === "date" ||
        type === "iban"
      ) {
        const customLabelInput = document.createElement("input");
        customLabelInput.type = "text";
        customLabelInput.key = key;
        customLabelInput.name = "customLabelInput";
        customLabelInput.placeholder = lng.get("formExport-placeholder");

        if (object.customLabel) {
          customLabelInput.value = object.customLabel;
        }

        const tableRow = addDescriptionRow(customLabelInput);

        nodeInput.parentElement.parentElement.appendChild(tableRow);
      } else if (type === "address" || type === "tel") {
        secondInput = document.createElement("input");
        secondInput.type = "checkbox";
        secondInput.checked = n !== -1;
        secondInput.id = key;
        if (type === "address") {
          const addressInput = document.createElement("input");
          addressInput.placeholder = lng.get("formExport-placeholder");
          addressInput.name = "address-input";

          if (object.customLabel) {
            addressInput.value = object.customLabel;
          }
          const addressTr = addDescriptionRow(addressInput);
          nodeInput.parentElement.parentElement.appendChild(addressTr);
        } else if (type === "tel") {
          const oneColumnInput = document.createElement("input");
          oneColumnInput.type = "checkbox";
          oneColumnInput.checked = object.singleColumn;
          oneColumnInput.classList.add("singleColumnExport");
          oneColumnInput.id = "singleColumnExport" + key;

          const oneColumnLabel = document.createElement("label");
          oneColumnLabel.htmlFor = "singleColumnExport" + key;
          oneColumnLabel.innerHTML = "In einer Spalte exportieren?";

          miscTr = document.createElement("tr");
          miscTr.style = "height: 40px;";
          const miscTdLabel = document.createElement("td");
          const miscTdSelect = document.createElement("td");
          let miscDiv = document.createElement("div");
          let miscLabel = document.createElement("label");
          miscTdLabel.colSpan = 2;
          miscTdSelect.colSpan = 8;
          miscLabel.textContent = "Sonstiges";

          miscDiv.classList.add("functions-container");

          miscTr.appendChild(miscTdLabel);
          miscTr.appendChild(miscTdSelect);
          miscTdLabel.appendChild(miscLabel);
          miscTdSelect.appendChild(miscDiv);
          miscDiv.appendChild(oneColumnInput);
          miscDiv.appendChild(oneColumnLabel);
        }

        thirdInput = document.createElement("label");
        thirdInput.htmlFor = key;
        thirdInput.innerHTML = "Exportbezeichnung aus Formular verwenden?";
      }
      if (value !== undefined) input.value = value;
    }

    labelInput.appendChild(label);

    if (input) nodeInput.appendChild(input);

    if (secondInput) nodeInput.appendChild(secondInput);
    if (thirdInput) nodeInput.appendChild(thirdInput);

    if (functions.length > 0) {
      const functionsTr = document.createElement("tr");
      const functionsTdLabel = document.createElement("td");
      const functionsTdSelect = document.createElement("td");
      let functionDiv = document.createElement("div");
      let functionSelect = document.createElement("select");
      let functionLabel = document.createElement("label");
      functionSelect.classList.add("function-select");
      functionsTdLabel.colSpan = 2;
      functionsTdSelect.colSpan = 8;
      functionLabel.textContent = "Funktion";

      functionDiv.classList.add("functions-container");

      functionsTdLabel.appendChild(functionLabel);
      functionDiv.appendChild(functionSelect);
      functionsTdSelect.appendChild(functionDiv);
      functionsTr.appendChild(functionsTdLabel);
      functionsTr.appendChild(functionsTdSelect);

      nodeInput.parentElement.parentElement.appendChild(functionsTr);

      if (miscTr !== null) {
        nodeInput.parentElement.parentElement.appendChild(miscTr);
      }

      const defaultOption = document.createElement("option");
      defaultOption.value = null;
      defaultOption.textContent = "Keine Funktion verwenden";
      functionSelect.appendChild(defaultOption);

      functions.map((f) => {
        const option = document.createElement("option");
        option.value = f.function;
        option.textContent = f.name;
        functionSelect.appendChild(option);
      });

      functionSelect.addEventListener("change", (event) => {
        let selectedValue =
          functionSelect.options[functionSelect.selectedIndex].value;

        if (selectedValue === "dynamicFunctionValue") {
          const functionNameInput = document.createElement("input");
          functionNameInput.id = "dynamicFunctionValue";
          functionsTr.appendChild(functionNameInput);
        } else {
          const functionNameInput = functionsTr.querySelector(
            "#dynamicFunctionValue"
          );
          if (functionNameInput) {
            functionNameInput.parentElement.removeChild(functionNameInput);
          }
        }
      });

      if (functionValue) {
        let selectedIndex =
          functions.findIndex((func) => func.function === functionValue) + 1;
        functionSelect.selectedIndex = selectedIndex;
        let selectedValue = functionSelect.options[selectedIndex].value;

        if (selectedValue === "dynamicFunctionValue") {
          const functionNameInput = document.createElement("input");
          functionNameInput.id = "dynamicFunctionValue";
          functionsTr.appendChild(functionNameInput);
          functionNameInput.value = object.dynamicFunctionValue;
        }
      }
    }

    schemaNode.addEventListener("dragstart", function (e) {
      e.dataTransfer.setData("text", text);
      e.dataTransfer.setData("key", key);
      e.dataTransfer.setData("type", type);

      if (defaultInputType) {
        e.dataTransfer.setData("defaultInputType", defaultInputType);
      }

      if (object && object.type) {
        e.dataTransfer.setData("object", JSON.stringify(object));
      }

      //if node is not inside the blueprint wrapper, tell the form wich node is currently draging
      if (!this.classList.contains("blueprint")) exportLis.data.inDrag = this;
    });
    schemaNode.addEventListener("dragend", function (e) {
      exportLis.data.inDrag = null;

      Array.from(
        exportLis.querySelectorAll(".input.insert-before, .input.insert-after")
      ).forEach((flagged) => {
        flagged.classList.remove("insert-before");
        flagged.classList.remove("insert-after");
      });
    });
    return schemaNode;
  }

  function keyToLabel(key) {
    const schema = that.formSchema;
    const keyParts = key.split("."); //currently max length is 2

    let schemaItem;

    for (let i = 0, len = schema.length; i < len; i++) {
      const item = schema[i];
      if (item.meta.name === keyParts[0]) {
        schemaItem = item;
        break;
      }
    }

    if (!schemaItem) return;
    switch (schemaItem.type) {
      case "image":
      case "sign":
        //ignore
        return;
      case "raffle":
      case "multichoice":
      case "textArea":
      case "text":
        return schemaItem.meta.name;
      case "address":
        const addressKey = keyParts[1];
        if (schemaItem.meta.name)
          return (
            schemaItem.meta.name +
            ": " +
            lng.get("form-input-address-" + addressKey)
          );
        return lng.get("form-input-address-" + addressKey);
      case "tel":
        const telKey = keyParts[1];
        if (schemaItem.meta.name)
          return (
            schemaItem.meta.name + ": " + lng.get("form-input-tel-" + telKey)
          );
        return lng.get("form-input-tel-" + telKey);
      case "default":
        const secondKey = keyParts[1];
        const defaultData = schemaItem.data;
        for (let i = 0, len = defaultData.length; i < len; i++) {
          const defaultItem = defaultData[i];
          if (defaultItem.name === secondKey) {
            if (schemaItem.meta.name)
              return schemaItem.meta.name + ": " + defaultItem.name;
            return defaultItem.name;
          }
        }
        break;
      default:
        console.error(`Type ${schemaItem.type} not implemented`);
    }
  }

  function addDescriptionRow(input) {
    const tableRow = document.createElement("tr");
    const tdLabel = document.createElement("td");
    const tdInput = document.createElement("td");
    let rowLabel = document.createElement("label");

    rowLabel.textContent = lng.get("formExport-placeholder");
    tdLabel.colSpan = 2;
    tdInput.colSpan = 8;

    tdLabel.appendChild(rowLabel);
    tdInput.appendChild(input);
    tableRow.appendChild(tdLabel);
    tableRow.appendChild(tdInput);

    return tableRow;
  }
}

Object.defineProperty(FormExportCsvBuilder, "reserved", {
  //Important!! Sync this with CustomerService.js
  value: [
    "empty",
    "partnerGroup",
    "partner",
    "form",
    "location",
    "marketnumber",
    "employee",
    "employeenumber",
    "date",
    "time",
    "customerid",
    "customerid_intern",
    "increasing_num",
    "iban",
    "subscriptionType",
    "delivery_end",
    "zipEdition",
  ],
});
